import React, { Fragment } from "react"
import { withStyles } from "@material-ui/core/styles"
import { Grid, Box } from "@material-ui/core/"
import styles from "./styles"

const PagesGrid = ({
  classes,
  actionBar,
  sideBox,
  content,
  noGrid,
  ...props
}) => {
  return (
    <Fragment>
      {actionBar}
      <Grid container className={classes.pagesContainer}>
        {content && sideBox ? (
          <Grid
            item
            xs={12}
            lg={9}
            md={8}
            sm={12}
            className={classes.ContentWithSideBoxContainer}
          >
            {noGrid ? (
              content
            ) : (
              <Box display="flex" flexWrap="wrap" style={{ height: "100%" }}>
                {content}
              </Box>
            )}
          </Grid>
        ) : (
          <Grid item xs={12} sm={12}>
            <Box display="flex" flexWrap="wrap" style={{ height: "100%" }}>
              {content}
            </Box>
          </Grid>
        )}
        {sideBox && (
          <Grid item xs={12} lg={3} md={4} sm={12}>
            <Box
              className={classes.sideBoxContainer}
              display="flex"
              flexDirection="row"
              flexWrap="wrap"
              justifyContent="center"
            >
              {sideBox}
            </Box>
          </Grid>
        )}
      </Grid>
    </Fragment>
  )
}

export default withStyles(styles)(PagesGrid)



// WEBPACK FOOTER //
// ./src/components/PagesGrid/index.jsx